// extracted by mini-css-extract-plugin
export default {"agents-table":"AgentsTable_agents-table__kz4Hf","agents-table__row":"AgentsTable_agents-table__row__PjWfZ"};